import React from 'react';
import { LabelInput, LabelSelect } from '../../../components/Input/Input';
import { ACCOUNT_PLAN_TYPE_OPTIONS, ACCOUNT_STATUS_OPTIONS } from '../../../core/constants/financial';
import FinancialFormModal from './FinancialFormModal';

const AccountPlanFormModal = ({ form, setForm, editingId, onSave, onClose, onDelete, saving, parentOptions }) => {
  const onChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <FinancialFormModal
      title={editingId ? 'Editar Conta' : 'Nova Conta'}
      onClose={onClose}
      onSave={onSave}
      onDelete={onDelete}
      saving={saving}
    >
      <div className="fd-form-row fd-form-row--code-name">
        <LabelInput
          label="Código"
          value={form.code}
          placeholder="Ex: 5.22"
          max={20}
          onChange={(value) => onChange('code', value)}
        />
        <LabelSelect menuPortalTarget={document.body}
          label="Tipo"
          options={ACCOUNT_PLAN_TYPE_OPTIONS}
          value={ACCOUNT_PLAN_TYPE_OPTIONS.find((o) => o.value === form.type)}
          placeholder="Selecione"
          onChange={(opt) => onChange('type', opt?.value || 'despesa')}
        />
      </div>

      <LabelInput
        label="Descrição"
        value={form.name}
        placeholder="Nome da conta contábil..."
        max={200}
        onChange={(value) => onChange('name', value)}
      />

      <div className="fd-form-row">
        <LabelSelect menuPortalTarget={document.body}
          label="Grupo (conta pai)"
          options={parentOptions}
          value={parentOptions.find((o) => String(o.value) === String(form.parent_id)) || null}
          placeholder="— Nível 1 (Grupo) —"
          isClearable
          onChange={(opt) => {
            onChange('parent_id', opt?.value || null);
            onChange('level', opt ? 2 : 1);
          }}
        />
        <LabelSelect menuPortalTarget={document.body}
          label="Status"
          options={ACCOUNT_STATUS_OPTIONS}
          value={ACCOUNT_STATUS_OPTIONS.find((o) => o.value === form.status)}
          placeholder="Selecione"
          onChange={(opt) => onChange('status', opt?.value || 'ativa')}
        />
      </div>
    </FinancialFormModal>
  );
};

export default AccountPlanFormModal;
